export function kebabToTitle(value: string): string {
	return value.split('-').map(v => v.charAt(0).toLocaleUpperCase() + v.substring(1)).join(' ');
}
